import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Typography,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { maintenanceSchedulingStyles } from "../../UI/styles/Main";

import MyDeviceLogo from "../../../assets/Card/MyDeviceLogo.png";
import { useGetDeviceManagementSearchDashboardQuery } from "../../../Api/apiSlice";
import DeviceCard from "./DeviceCard";

const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "20px",
  borderRadius: "15px",
  boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
  backgroundColor: "#ffffff",
  width: "100%",
  maxWidth: "400px",
});

const IconBox = styled(Box)({
  backgroundColor: "#ffebee",
  borderRadius: "50%",
  padding: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StatusDot = styled(Box)({
  width: "10px",
  height: "10px",
  // backgroundColor: "#4caf50",
  borderRadius: "50%",
  marginLeft: "5px",
});

const DataItem = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  margin: "5px 0",
});

const RequestButton = styled(Button)({
  backgroundColor: "#ff9800",
  color: "white",
  marginTop: "15px",
  "&:hover": {
    backgroundColor: "#fb8c00",
  },
});

const SendButton = styled(Button)({
  backgroundColor: "#ff9800", // Orange color
  color: "white",
  "&:hover": {
    backgroundColor: "#fb8c00", // Slightly darker on hover
  },
});

// Dummy API Data (Replace this with actual API response)
const deviceData = [
  {
    id: "001",
    passcode: "1234abcd!",
    assignedVehicle: "Vehicle 101",
    location: "New York, NY",
    name: "GPS Tracker A",
    batteryLevel: "85%",
    signalStrength: "Good",
    lastActive: "2024-01-10, 11:00",
    isConnected: true,
  },
  {
    id: "002",
    passcode: "5678xyz!",
    assignedVehicle: "Vehicle 102",
    location: "Los Angeles, CA",
    name: "GPS Tracker B",
    batteryLevel: "60%",
    signalStrength: "Weak",
    lastActive: "2024-01-09, 14:30",
    isConnected: false,
  },
  {
    id: "003",
    passcode: "91011def!",
    assignedVehicle: "Vehicle 103",
    location: "Chicago, IL",
    name: "GPS Tracker C",
    batteryLevel: "95%",
    signalStrength: "Good",
    lastActive: "2024-01-08, 09:15",
    isConnected: true,
  },
];

function DashboardMyDeviceCard() {
  const search = "";
  const status = "";
  const {
    data: deviceData,
    isLoading: isDevicesLoading,
    error: deviceError,
  } = useGetDeviceManagementSearchDashboardQuery({ search, status });

  console.log("My Device", deviceData);
  const currentDevice = deviceData;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const isActive = status === "Running";

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  // Handlers for Next and Prev buttons
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % deviceData.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + deviceData.length) % deviceData.length
    );
  };

  return (
    <div>
     <DeviceCard deviceData={deviceData} />
    </div>
  );
}

export default DashboardMyDeviceCard;
